import classnames from 'classnames'
import { TabButtonProps } from './types'

export const TabButton: React.FC<TabButtonProps> = ({
    id,
    label,
    badge,
    isActive,
    onClick,
}) => {
    const className = classnames(
        'text-label-medium px-3 py-2 relative focus:outline-0 whitespace-nowrap',
        {
            'group/tab-button': !isActive,
            'text-subtle hover:text-regular': !isActive,
            'text-azure cursor-default': isActive,
        }
    )

    return (
        <button
            className={className}
            data-testid={`tab-${id}`}
            onClick={onClick}
        >
            {isActive && (
                <div className="pointer-events-none absolute inset-0 border-b-2" />
            )}
            <div className="flex items-center gap-2 rounded group-focus/tab-button:outline group-focus/tab-button:outline-4 group-focus/tab-button:outline-azure/35 group-active/tab-button:outline-0">
                {label}
                {badge}
            </div>
        </button>
    )
}
